import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import SubNavigation from "./SubNavigation";
import AuthorizedUser from "../utils/AuthorizedUser";
import AuthorizedUserContext from "../utils/AuthorizedUserContext";

function ReportsTabs(props) {
	const authenticatedUser = useContext(AuthorizedUserContext);
	const tabs = [{
		label: "Overview",
		value: "overview",
		hasAccess: true
	},{
		label: "Social Media",
		value: "social-media",
		hasAccess: AuthorizedUser.hasSocialMediaReports(authenticatedUser)
	},{
		label: "G Suite",
		value: "gsuite",
		hasAccess: AuthorizedUser.hasGSuiteReports(authenticatedUser)
	},{
		label: "Outlook",
		value: "outlook",
		hasAccess: AuthorizedUser.hasExchangeReports(authenticatedUser)
	},{
		label: "Web Search",
		value: "web-search",
		hasAccess: AuthorizedUser.hasWebSearchReports(authenticatedUser)
	},{
		label: "Shareit",
		value: "shareit",
		hasAccess: AuthorizedUser.hasShareitReports(authenticatedUser)
	},{
		label: "Audit Trail",
		value: "audit-trail",
		hasAccess: AuthorizedUser.isAdmin(authenticatedUser)
	},{
		label: "Alert Summary",
		value: "alert-summary",
		hasAccess: AuthorizedUser.isAdmin(authenticatedUser)
	}];

	let {tabClicked, selectedTab, setBannerClassName, hasNudgeBanner} = props;

	return (
		<SubNavigation
			useSelect
			tabs={tabs}
			title="Reports"
			selectedTab={selectedTab}
			tabClicked={tabClicked}
			hasNudgeBanner={hasNudgeBanner}
			setBannerClassName={setBannerClassName} />
	);
}

ReportsTabs.propTypes = {
	hasNudgeBanner: PropTypes.bool,
	tabClicked: PropTypes.func.isRequired,
	setBannerClassName: PropTypes.func.isRequired,
	selectedTab: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired
};

export default ReportsTabs;